import debounce from 'lodash.debounce'
import { SearchIcon } from 'lucide-react'
import { useCallback, useRef, useState } from 'react'

import { useFiltersActions, useSearchQuery } from '@/stores'
import { cn } from '@/utils'

export const Search = () => {
  const searchQuery = useSearchQuery()
  const { setSearchQuery } = useFiltersActions()
  const [isSearchOpen, setIsSearchOpen] = useState(!!searchQuery)
  const [inputValue, setInputValue] = useState(searchQuery)
  const inputRef = useRef<HTMLInputElement>(null)

  const debouncedSetSearchQuery = useCallback(debounce(setSearchQuery, 150), [])

  const handleOpen = () => {
    if (!isSearchOpen) {
      setIsSearchOpen(true)
      setTimeout(() => inputRef.current?.focus(), 50)
    }
  }

  const handleSearchBlur = () => {
    if (!inputValue) {
      setIsSearchOpen(false)
    }
  }

  return (
    <div
      className={cn(
        'flex items-center h-8 rounded-md border bg-white transition-all duration-200 overflow-hidden',
        isSearchOpen ? 'w-48 border-input' : 'w-8 cursor-pointer border-input',
      )}
      onClick={handleOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleOpen()
      }}
    >
      <SearchIcon className="size-4 shrink-0 mx-1.75 text-muted-foreground" />
      {isSearchOpen && (
        <input
          ref={inputRef}
          type="text"
          placeholder="Search..."
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value)
            debouncedSetSearchQuery(e.target.value)
          }}
          onBlur={handleSearchBlur}
          className="h-full w-full bg-transparent pr-3 text-sm placeholder:text-muted-foreground focus-visible:outline-none"
        />
      )}
    </div>
  )
}
